import { jsonMember, jsonObject } from 'typedjson';
import { Guid, Nillable } from '@web/utils';
import { AdminBannerStatus } from '../../enums/admin-banner-status';
import { BannerLocationType } from '../../../shared/enums/banner-location-type';
import { dateWithOffsetSerializer } from '@web/common';

@jsonObject
export class AdminBannerUpdateRequest {
  @jsonMember(String)
  public readonly url?: Nillable<string>;

  @jsonMember(String)
  public readonly fileId!: Guid;

  @jsonMember(String)
  public readonly smallFileId?: Nillable<Guid>;

  @jsonMember(String)
  public readonly status!: AdminBannerStatus;

  @jsonMember(String)
  public readonly location?: Nillable<BannerLocationType>;

  @jsonMember(Date, { serializer: dateWithOffsetSerializer() })
  public readonly visibilityStartDate?: Nillable<Date>;

  @jsonMember(Date, { serializer: dateWithOffsetSerializer() })
  public readonly visibilityEndDate?: Nillable<Date>;

  public constructor(
    private data: {
      fileId: Guid;
      location?: Nillable<BannerLocationType>;
      smallFileId?: Nillable<Guid>;
      status: AdminBannerStatus;
      url?: Nillable<string>;
      visibilityStartDate?: Nillable<Date>;
      visibilityEndDate?: Nillable<Date>;
    },
  ) {
    this.fileId = this.data.fileId;
    this.location = this.data.location;
    this.smallFileId = this.data.smallFileId;
    this.status = this.data.status;
    this.url = this.data.url;
    this.visibilityStartDate = this.data.visibilityStartDate;
    this.visibilityEndDate = this.data.visibilityEndDate;
  }
}
